
import { installAuthFetch } from './utils/authFetch';
import { registerServiceWorker } from './utils/pushNotifications';
import KeycloakProviderWrapper from './keycloakProvider';
import ErrorBoundary from './ErrorBoundary';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { ToastProvider } from './components/common/ToastProvider';
import { DarkModeProvider } from './contexts/DarkModeContext';

installAuthFetch();

// Registered unconditionally (not just when a user opts into push
// notifications) — a browser only offers to install/pin this app when a
// service worker is active, so waiting for the push opt-in meant most users
// never saw an install prompt at all.
registerServiceWorker();

createRoot(document.getElementById('root')!).render(
  <ErrorBoundary>
    <DarkModeProvider>
      <ToastProvider>
        <KeycloakProviderWrapper>
          <App />
        </KeycloakProviderWrapper>
      </ToastProvider>
    </DarkModeProvider>
  </ErrorBoundary>
);
